import {PANELMANAGER_MOVE_PANEL} from '../../constants';

export type MovePanelAction = {
    type : typeof PANELMANAGER_MOVE_PANEL;
    oldPanelIndex : number;
    panelIndex : number;
}

/**
 * @memberOf! Actions
 * Either the panelId or the panelIndex must be set
 * @param {Number} oldPanelIndex the old tab index of the panel
 * @param {Number} panelIndex the new tab index of the panel
 *
 * @return {MovePanelAction}
 */
const movePanel = ( oldPanelIndex : number, panelIndex : number ) : MovePanelAction => {
    return {
        type: PANELMANAGER_MOVE_PANEL,
        oldPanelIndex,
        panelIndex
    };
}
export type MovePanel = typeof movePanel;

export default movePanel;
